import { Flex } from 'antd';
import React from 'react';

import { BORDER_MAIN } from '../../const';
import { ButtonExport, ButtonExportProps } from '../buttonExport';
import ButtonToday from '../buttonToday';
import ButtonPagination from './buttonPagination';
import SelectPeriod from './selectPeriod';
import SwitchTimeLine from './switchTimeLine';

interface GantSettingPanelProps extends ButtonExportProps {}

const GantSettingPanel: React.FC<GantSettingPanelProps> = ({ treeRef, gantHeaderRef, gantBodyRef }) => {
    return (
        <Flex
            justify={'space-between'}
            style={{ padding: '5px 0', borderBottom: BORDER_MAIN }}
            gap={20}
            align={'center'}
        >
            <ButtonExport treeRef={treeRef} gantBodyRef={gantBodyRef} gantHeaderRef={gantHeaderRef} />
            <ButtonPagination />
            <Flex justify={'space-between'} gap={10} align={'center'}>
                <SwitchTimeLine />
                <ButtonToday />
                <SelectPeriod />
            </Flex>
        </Flex>
    );
};

export default GantSettingPanel;
